module.exports = __webpack_public_path__ + "img/lab7.dd4634ab.jpeg";